import React from 'react';
import { withRouter } from 'react-router-dom';

import { IAppPropsWithRoute } from '../../../common/types';
import { makeStyles, MuiThemeProvider } from '@material-ui/core/styles';
import { Paper, Grid } from '@material-ui/core';
import themeDark from '../../shared/themeDark';
import api from '../../../store/api';
import ErrorMessage from '../../shared/messages/ErrorMessage'
import { addTaskForEvent, removeTaskForEvent } from '../../../store/signalr/tasksForEvents';
import eventNames from '../../../store/signalr/eventNames';
import CalloutTableForManager from './CalloutTableForManager'
import { IRequestCalloutDTO } from '../calloutRequested/types/IRequestCalloutDTOs';
import IAuthState from '../../../interfaces/IAuthState';
import AssignVehicleModal from './assignVehicle/AssignVehicleModal';

interface AgedCareCalloutsForManagerWidgetProps extends IAppPropsWithRoute {
    selectedLocations: string[]|null,
    authStore: IAuthState,
};

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex', flexDirection: 'column',
    },
    container: {
        minHeight: 'max(100vh - 60px, 700px)',
        backgroundSize: '100%', backgroundRepeat: 'no-repeat', borderRadius: '0',
    },
    bodyContainer: {
        height: '100%', margin: 'auto', width: '100%'
    },
    headingTop: {
        marginTop: 30,
        marginBottom: 20,
        fontSize: 36,
        paddingLeft: 40,
        fontWeight: 900,
        textAlign: 'left'
    }
}));




const componentTaskId = "agedCareCalloutsForManagerWidget";
const AgedCareCalloutsForManagerWidget: React.FC<AgedCareCalloutsForManagerWidgetProps> = ({
    selectedLocations, 
    authStore,
    }) => {
    const classes = useStyles();
    const [errorMessage, setErrorMessage] = React.useState("");
    const [loading, setLoading] = React.useState(false);
    const [calloutList, setCalloutList] = React.useState<IRequestCalloutDTO[]>([]);
    const [showVehicleModal, setShowVehicleModal] = React.useState(false);
    const [requestCalloutIdForAssign, setRequestCalloutIdForAssign] = React.useState('');

    const getCallouts = async (): Promise<void> => {
        setErrorMessage('');
        setLoading(true);
        try {
            const requestBody = {
                locations: selectedLocations?.length ? selectedLocations : null
            };
            const res = await api.getRequestCalloutList(``, requestBody);
            setLoading(false);
            if (!res.data.errorRaised) {
                setCalloutList(res.data?.model);
            } else {
                throw (res.data.errorMessage);
            }
        } catch (error) {
            console.error(error);
            setErrorMessage('Error while getting callouts, try to refresh the page');
            setLoading(false);
        }
    }

    const assignCalloutRequestToVehicle = async (requestCalloutId: string, vehicle: string): Promise<void> => {
        setErrorMessage('');
        setLoading(true);
        try {
            const res = await api.assignCalloutRequestToVehicle(``, {requestCalloutId, vehicle});
            setLoading(false);
            if (res.hasError) {
                throw (res.data.errorMessage);
            }
        } catch (error) {
            console.error(error);
            setErrorMessage('Error while assigning callout request');
            setLoading(false);
        }
    }

    const assignVehicleModalOnClose = async (requestCalloutId: string, vehicle: string, isCancel: boolean) =>{
        if(!isCancel)
            await assignCalloutRequestToVehicle(requestCalloutId, vehicle);

        setShowVehicleModal(false);
        setRequestCalloutIdForAssign('');
    }

    const openAssignVehicleModal = (requestCalloutId: string) =>{
        setRequestCalloutIdForAssign(requestCalloutId);
        setShowVehicleModal(true);
    }

    React.useEffect(() => {
        if(selectedLocations !== null){
            getCallouts();
        }
    }, [selectedLocations]);

    const whenCalloutEventDo = () => {
        getCallouts();
    }

    React.useEffect(() => {
        addTaskForEvent(eventNames.refreshCallouts, componentTaskId, whenCalloutEventDo);
        return () => {
            removeTaskForEvent(eventNames.refreshCallouts, componentTaskId);
        }
    }, [whenCalloutEventDo]);


    return (
        <>
            <MuiThemeProvider theme={themeDark}>
                <Paper className={classes.container} square={true}>
                    <div className={classes.bodyContainer}>
                        <Grid container>
                            <Grid item xs={12}>
                                <div className={classes.headingTop}> Medical Response Callouts</div>
                            </Grid>
                            {errorMessage && <ErrorMessage errorMessage={errorMessage} />}
                            <Grid item xs={12}>
                                <CalloutTableForManager 
                                    calloutList={calloutList}
                                    openAssignVehicleModal={openAssignVehicleModal} 
                                />
                            </Grid>
                        </Grid>
                    </div>
                </Paper>
                <AssignVehicleModal open={showVehicleModal} onClose={assignVehicleModalOnClose} requestCalloutIdForAssign={requestCalloutIdForAssign} />
            </MuiThemeProvider>
        </>
    );
}

export default withRouter(AgedCareCalloutsForManagerWidget);